import SmsIconMUI from '@mui/icons-material/Sms';

export const SmsIcon = SmsIconMUI;
